import React, { useEffect, useState } from 'react';
import BundleData from '../../components/Bundle/BundleData/BundleData';
import { useNavigate } from 'react-router-dom';
import Menu from '../../components/Menu/Menu';
import { BundleDataProps } from '../../components/Bundle/BundleData/BundleDataTypes';
import { defaultMenuProps } from '../../constants/constants';
import { MenuProps } from '../../components/Menu/MenuTypes';

const CrearBundle = (): React.ReactElement => {
  const navigate = useNavigate();
  const [menuProps, setMenuProps] = useState<MenuProps>(defaultMenuProps);
  const [bundleData, setBundleData] = useState<BundleDataProps>({bundle:{ _id: '' }});
  const [loaded, setLoaded] = useState<boolean>(false);

  useEffect(() => {
    setLoaded(true)
  }, []);
  
  return(
    <React.Fragment>
      <div id="menu">
        <Menu items={ menuProps.items } />
      </div>

      <div id="app-content">
        <header className="table-header mb-4">
          <h1>Crear bundle</h1>
          <span></span>
        </header>

        { loaded && 
          <BundleData bundle={bundleData.bundle} />
        }
      </div>
    </React.Fragment>
  )
};

export default CrearBundle;
